import { CircleArrowRight } from "lucide-react";
import { useTranslation } from "react-i18next";

import { IPatientList } from "@/app/mock-data/getPatientsList";
import { useRouter } from "@tanstack/react-router";
import { useAppDispatch } from "@/app/store";
import { setSelectedConnectionId } from "@/app/store/connection/connectionSlice";
import { resetStatus } from "@/app/store/patient/patientSlice";
import { setItemSessionStorage } from "@/lib/utils";
import { ELocalStorageKeys } from "@/app/types/localStorage";

interface ViewPatientProps {
  patient: IPatientList;
}

export const ViewPatientButton = ({ patient }: ViewPatientProps) => {
  const { t } = useTranslation();
  const router = useRouter();
  const dispatch = useAppDispatch();

  const handleClick = () => {
    dispatch(setSelectedConnectionId(patient.id));
    setItemSessionStorage(ELocalStorageKeys.PATIENT, patient.id);
    dispatch(resetStatus());
    router.navigate({
      to: `/dashboard/patients/${patient.firstname.toLowerCase()}-${patient.surnames.toLowerCase()}-${patient.id.slice(-6)}`,
    });
  };

  return (
    <button
      className="flex gap-2 items-center cursor-pointer hover:text-red"
      onClick={handleClick}
    >
      <CircleArrowRight size={24} className="text-red" />
      {t("patients.search.view_patient")}
    </button>
  );
};
